import React from 'react';
import PropTypes from 'prop-types';

import * as flags from './svg'
import * as constants from "./constants";

const Flag = ({ country, size, opacity, ...restOfProps }) => {
  const { width: widthBase, height: heightBase } = constants.DIMENSIONS;
  const DIMENSIONS = {
    xsmall: {
      width: widthBase * 0.13,
      height: heightBase * 0.13
    },
    small: {
      width: widthBase * 0.57,
      height: heightBase * 0.57
    },
    normal: {
      width: widthBase,
      height: heightBase
    },
    large: {
      width: widthBase * 1.43,
      height: heightBase * 1.43
    },
    xlarge: {
      width: widthBase * 2,
      height: heightBase * 2
    }
  };

  const { width, height } = DIMENSIONS[ size ];
  const Component  = flags[constants.FLAG_LIST[country].component];

  return (
    <Component
      width={width}
      height={height}
      fillOpacity={opacity}
    />
  )
};

Flag.propTypes = {
  size: PropTypes.oneOf(constants.SIZES),
  opacity: PropTypes.number,
  country: PropTypes.oneOf(Object.keys(constants.FLAG_LIST))
};

Flag.defaultProps = {
  size: 'normal',
  country: 'united-states-of-america',
  opacity: 1
};

export default Flag;
export const FLAGS = constants.FLAG_LIST;
export const flagList = Object.keys(constants.FLAG_LIST);
